import { render, staticRenderFns } from "./Tab4.vue?vue&type=template&id=75b1525b&"
import script from "./Tab4.vue?vue&type=script&lang=ts&"
export * from "./Tab4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports